<body class="ltr main-body leftmenu">

    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid scrol">
            <div class="inner-body">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                        {{' Add New Exam Code Record'
                                                        | translate}}
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    {{ ' Add New Exam Code Information' | translate }}
                                                </p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <hr>

                                <div class="row row-sm add-form">
                                    <form autocomplete="off" class="p-0" novalidate [formGroup]="NewEmCdForm">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="row clearfix">
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Course Code</mat-label>
                                                                <mat-select #select3 class="colorblack"
                                                                    formControlName="CoCode">
                                                                    <mat-select-filter *ngIf="select3.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'CoName'" [array]="CourseList"
                                                                        (filteredReturn)="filteredListCourse =$event"></mat-select-filter>
                                                                    <mat-option onkeydown="return (event.keyCode!=13);"
                                                                        *ngFor="let item of filteredListCourse"
                                                                        [value]="item.CoCode"
                                                                        (click)="getTable(item.CoCode)">
                                                                        {{item.CoCode}} - {{item.CoName}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="NewEmCdForm.controls['CoCode'].touched && NewEmCdForm.controls['CoCode'].errors?.required">
                                                                This Field Is Mandatory
                                                            </mat-error> -->
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="table" class="table-responsive mt-4">
                                                    <table id="datatable" class="table table-bordered text-left">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                    Exam Code
                                                                </th>
                                                                <th class="f600">
                                                                    New Code
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="table_data" formArrayName="NewCdArray">
                                                            <!-- examSemList -->
                                                            <tr *ngFor="let sem of getNewCdArrayControls(); let i = index"
                                                                [formGroupName]="i">
                                                                <td>
                                                                    <input class="form-control input-sm"
                                                                        formControlName="NeEmCode">
                                                                </td>
                                                                <td>
                                                                    <input class="form-control input-sm"
                                                                        formControlName="NeNewCode">
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- <div class="col-sm-12">
                                            <button type="button" *ngIf="newCodeUpdate"
                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                            (click)="update()">
                                                Update
                                            </button>
                                            
                                        </div> -->
                                                <div class="col-sm-12 row">
                                                    <div class="col-sm-12 prpl">
                                                        <button type="button" *ngIf="newCodeUpdate"
                                                            class="btn btn-primary btn-icon-text floatright mt-1"
                                                            (click)="update()">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="20vh" src="../../assets/img/edit1.gif"
                                                                    style="margin-right: 5px;">
                                                                Update
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>